import React from 'react'
import { Spinner } from './styles'

function BtnLoader() {
    return <Spinner />
}

export default BtnLoader